import React from 'react';
import { Slide } from '../../components/deck/Slide';
import { Caption, Eyebrow, INK, Label, Reveal, Title } from '../../components/deck/Type';
import { ECOSYSTEM_SOURCE } from '../../data/ecosystem';
const SERIF = {
  fontFamily: 'var(--font-serif)'
} as const;
const initialSegments = ['VC funds', 'Corporate VCs', 'Family offices', 'Accelerators', 'Angel networks', 'Private equity'];
const expansion = ['Corporate innovation', 'M&A', 'Procurement', 'Research / technology assessment'];
const assumptions = [{
  value: '1,000',
  label: 'Organisations (1% of 100K+)'
}, {
  value: '× $499',
  label: 'Pro workspace / month'
}, {
  value: '× 12',
  label: 'Months'
}, {
  value: '≈ $6M',
  label: 'ARR — workspaces only',
  highlight: true
}];
export function MarketOpportunitySlide() {
  return <Slide source={ECOSYSTEM_SOURCE} data-id="element-320" data-mp="14rvuz1mxm7pb">
      <div className="flex items-start justify-between gap-[3cqw]" data-id="element-321" data-mp="14qucwd7i0ky3">
        <div className="max-w-[64%]" data-id="element-322" data-mp="zskgy0dy9gbf">
          <Eyebrow data-id="element-323" data-mp="ztlz0otdv32n">Market opportunity</Eyebrow>
          <Title className="mt-[2.2cqh]" data-id="element-324" data-mp="2abgxam30cpqm">A large, countable initial market — before expansion.</Title>
        </div>
        <Caption className="max-w-[28%] text-right" data-id="element-325" data-mp="2f25os1eotmpr">
          Bottom-up from organisation counts and published pricing. Not a claimed customer count.
        </Caption>
      </div>

      <div className="mt-auto grid grid-cols-[1fr_34%] gap-[3cqw]" data-id="element-326" data-mp="25buk2cn6j9ht">
        <Reveal delay={0.05} className="border border-[#3B8CFF]/40 bg-[#3B8CFF]/[0.05] p-[1.8cqw]" data-id="element-327" data-mp="259zzx0jqfles">
          <Label tone={INK.blue} data-id="element-328" data-mp="2szlutbt2negz">Initial market · VC / private markets</Label>
          <div className="mt-[2.4cqh] flex gap-[4cqw]" data-id="element-329" data-mp="2y09o644rw7ed">
            <div data-id="element-330" data-mp="2j40qh70j6242">
              <p className="text-[3.6cqw] leading-none text-[#F4F7FC]" style={SERIF} data-id="element-331" data-mp="2j2h9fe71vn18">
                100K+
              </p>
              <div className="mt-[1cqh]" data-id="element-332" data-mp="2o0r47nov4lmb">
                <Label data-id="element-333" data-mp="17olr5wkumy5s">Capital organisations</Label>
              </div>
            </div>
            <div data-id="element-334" data-mp="1cnf9q3eztfct">
              <p className="text-[3.6cqw] leading-none text-[#F4F7FC]" style={SERIF} data-id="element-335" data-mp="1cnygcnz70hbj">
                35K+
              </p>
              <div className="mt-[1cqh]" data-id="element-336" data-mp="3f8snp7okbeow">
                <Label data-id="element-337" data-mp="3fbwy4msmf6o0">Institutional LPs</Label>
              </div>
            </div>
          </div>
          <p className="mt-[3cqh] text-[1.02cqw] text-[#C3CBD9]" data-id="element-338" data-mp="3adddqqtoe2xr">{initialSegments.join(' · ')}</p>
        </Reveal>

        <Reveal delay={0.12} className="border border-white/10 p-[1.8cqw]" data-id="element-339" data-mp="30lhdb944a0qd">
          <Label tone={INK.emerald} data-id="element-340" data-mp="30j3h2wxpaih8">Expansion · same architecture</Label>
          <ul className="mt-[2cqh]" data-id="element-341" data-mp="2vno9gmqadit9">
            {expansion.map(e => <li key={e} className="border-b border-white/8 py-[1.4cqh] text-[1.15cqw] text-[#E3E8F1]" data-id="element-342" data-mp="2rk9odhnhqc8y">
                {e}
              </li>)}
          </ul>
          <p className="mt-[1.6cqh] text-[0.86cqw] text-[#6B7588]" data-id="element-343" data-mp="2hmlj3xs9dmcj">Not included in initial-market figures.</p>
        </Reveal>
      </div>

      <Reveal delay={0.24} className="mt-[3cqh] border-t border-white/12 pt-[2.2cqh]" data-id="element-344" data-mp="ksqslen2ulvv">
        <Label data-id="element-345" data-mp="fw0datj3jubi">Illustrative bottom-up math · visible assumptions</Label>
        <div className="mt-[1.6cqh] grid grid-cols-4" data-id="element-346" data-mp="nergoyf520fg">
          {assumptions.map((a, i) => <div key={a.label} className={i === 0 ? '' : 'border-l border-white/10 pl-[1.4cqw]'} data-id="element-347" data-mp="sdb5r7p13sc1" data-mpi={i}>
              <p className="text-[2cqw] leading-none" style={{
            ...SERIF,
            color: a.highlight ? INK.emerald : '#F4F7FC'
          }} data-id="element-348" data-mp="x4kso0j70hk8">
                {a.value}
              </p>
              <div className="mt-[0.9cqh]" data-id="element-349" data-mp="122megt806uze">
                <Label data-id="element-350" data-mp="4g5efg7vy39y">{a.label}</Label>
              </div>
            </div>)}
        </div>
      </Reveal>
    </Slide>;
}